import * as React from 'react'
import { StyledPageSubHeaderSide } from './PageSubHeaderSide.styled'

export interface PageSubHeaderSideProps {
  content: string
  onClick?: (e?: React.MouseEvent) => void
}

export const PageSubHeaderSideStorybook: React.FC<PageSubHeaderSideProps> = ({
  content,
  ...props
}) => <StyledPageSubHeaderSide {...props}>{content}</StyledPageSubHeaderSide>
